export const RULE_REQUIRED = {
  required: true,
  message: 'Este campo es obligatorio',
};

export const RULE_ONLY_NUMBERS = {
  pattern: new RegExp("^[0-9]*$"),
  message: "Este campo solo acepta números"
}

export const LABEL_ALIGN = "left";

export const DATE_FORMAT = 'DD/MM/YYYY';

export const WHATSAPP_COLOR = '#25D366';

export const CONTACT_ICON_SIZE = 18;

export const CASA_CENTRAL_ID = 8;

export const MAIL_COLOR = '#7091F5';

export const PENDIENTE_COLOR = '#FF9843';

export const TYPE_TAB = '';

export const FACTOR_CONVERSION_VOLUMEN = 100000;

export const FORM_ITEM_STYLE = {
  marginBottom: '0px',
};

export const PRECIOS_TIPOS = {
  LISTA_GENERAL: 1,
  ACUERDOS: 2,
  LISTA_GENERAL_REDESPACHOS: 3,
  ACUERDOS_REDESPACHOS: 4,
  LISTA_PROVEEDORES_REDESPACHO: 5,
};

export const PRECIOS_CONFIG = {
  [PRECIOS_TIPOS.LISTA_GENERAL]: {
    title: 'Lista de precios de ',
    to: '/precios',
    breadcrumbTitle: 'Lista de precios',
  },
  [PRECIOS_TIPOS.ACUERDOS]: {
    title: 'Acuerdo de precios de ',
    to: '/acuerdos',
    breadcrumbTitle: 'Acuerdos',
  },
  [PRECIOS_TIPOS.LISTA_GENERAL_REDESPACHOS]: {
    title: 'Lista de precios de ',
    to: '/precios?tab=3',
    breadcrumbTitle: 'Lista de precios redespacho',
  },
  [PRECIOS_TIPOS.ACUERDOS_REDESPACHOS]: {
    title: 'Acuerdo de redespacho de ',
    to: '/acuerdos-redespachos',
    breadcrumbTitle: 'Acuerdos Redespachos',
  },
  [PRECIOS_TIPOS.LISTA_PROVEEDORES_REDESPACHO]: {
    title: 'Lista de precios (proveedores) de ',
    to: '/redespachantes-precios',
    breadcrumbTitle: 'Lista de precios del redespachante',
  },
};

export const FILIALES_ACUERDOS_TITLE = "Filiales destino donde se aplica la bonificación";

export const LABEL_HEREDAR = 'Puede usar acuerdo cuando es remitente';

export const CONFIRMATION_MESSAGES = {
  DELETE_CONFIRMATION: "¿Está seguro de que desea eliminar?",
};

export const PRIVILEGES_MESSAGES = {
  BUTTON: "No tienes privilegios para realizar esta acción.",
  VIEW: "No tienes privilegios para acceder a esta página.",
}

export const DISTRIBUCION_TIPO = {
  TRONCAL: 1,
  LATERAL: 2,
  ULTIMA_MILLA: 3,
  DESPACHO: 4,
  ENTREGA: 5
};

export const VEHICULOS_TIPOS = {
  TRACTOR: 1,
  ACOPLADO: 2,
  SEMI: 3,
  UTILITARIO: 4,
  CHASIS: 5,
}

export const FILIALES_TIPOS = {
  SUCURSAL: 1,
  SUCURSAL_SUBNODO: 2,
  NODO_TRANSFERENCIA: 3,
  NODO: 4,
  RECEPTORIA: 5,
  PICKUP: 6,
  SUB_FRANQUICIA: 7,
  FRANQUICIA: 8,
  ADM: 9,
}

export const PEDIDOS_TIPOS = {
  EVENTUAL: 1,
  FRECUENTE: 2,
  HISTORIAL: 3,
}

export const DESTINOS_TIPOS = {
  UNO: 1,
  VARIOS: 2,
}

export const LINEAS_TIPOS = {
  DESPACHO: 1,
  ENTREGA: 2,
  TRONCAL: 3,
  LATERAL: 4,
};

export const SECCIONES_TIPOS = {
  SECCION_VENTAS_PREPAGOS: 1,
  SECCION_ENVIOS_PALLET: 2,
  SECCION_ENVIOS_DISTANCIA: 3,
  SECCION_BOLSINES: 5,
  SECCION_PACKS: 6,
  SECCION_ARTICULO_ESPECIFICO: 7,
  SECCION_BOLSAS_DE_SEGURIDAD: 9,
  SECCION_ADICIONALES: 10,
  SECCION_SOBRES: 12,
  SECCION_ENVIOS_PREPAGO: 14,
  SECCION_MATERIALES_BOLSAS_FILIALES: 15,
}

export const PERSONAL_TIPOS = {
  DEPENDENCIA: 1,
  CONTRATADO: 2,
  TITULAR: 3,
}

export const ENTIDADES_TIPOS = {
  FILIAL: 1,
  PROVEEDOR: 2,
  CLIENTE: 3,
}

export const REDES_TIPOS = {
  CREDIFIN: 1,
  GEFCO: 2,
  OTRA: 3,
}

export const COND_VENTAS_TIPOS = {
  CONTADO: 1,
  PAGO_DESTINO: 2,
  CUENTA_CTE: 3,
  CUENTA_CTE_15: 4,
  CUENTA_CTE_30: 5,
}

export const LISTA_PRECIOS = {
  DISTANCIA_PESO: 1,
  DISTANCIA_VOLUMEN: 2,
  PREPAGO: 3,
  UPGRADE_PREPAGO: 4,
  PACK: 6,
  BOLSAS: 8,
}

export const DOMICLIO_ORIGEN = {
  CLIENTE: 1,
  DOMICILIO: 2,
  PUNTO_ENTREGA: 3,
  ENTREGA_RETIRO: 4,
}

export const SISTEMA_TIPOS = {
  ADMINISTRACION: 1,
  FACTURACION: 2,
  APP: 3,
  AUTOGESTION: 4,
  PICKUP: 5,
}

export const CONTRATOS_TIPOS = {
  FRANQUICIA: 1,
  SUCURSAL: 2,
  CONTRATISTA: 3,
}

export const GUIAS_TIPOS = {
  GUIA: 1,
  BOLSINES: 2,
  BINS: 3,
  COLECTORA: 4,
  CONFORMADO: 5,
  PICKUP: 6,
  GUIA_NC: 7,
  ENVIO_CREDITO_PREPAGO: 8,
  GUIA_REMITO: 9,
}

export const CLIENTES = {
  WINPLAY: 393853,
};

//articulos VTASUBRUBROARTI
export const SUBRUBRO_ARTICULOS = {
  SUBRUBRO_ARTI_AGROPECUARIO: 1,
  SUBRUBRO_ARTI_TV_NOTEBOOK_Y_PC: 2,
  SUBRUBRO_ARTI_BAZAR_Y_CASA: 3,
  SUBRUBRO_ARTI_BEBIDAS_Y_ALIMENTOS: 4,
  SUBRUBRO_ARTI_CONSTRUCCION: 5,
  SUBRUBRO_ARTI_ELECTRODOMESTICOS: 6,
  SUBRUBRO_ARTI_HERRAMIENTAS: 7,
  SUBRUBRO_ARTI_CELULARES_Y_TABLETS: 8,
  SUBRUBRO_ARTI_NEUMATICOS: 9,
  SUBRUBRO_ARTI_REPUESTOS_Y_AUTOPARTES: 10,
  SUBRUBRO_ARTI_INDUMENTARIA_Y_CALZADOS: 11,
  SUBRUBRO_ARTI_EQUIP_MEDICO: 12,
  SUBRUBRO_ARTI_ELECTRONICA: 13,
  SUBRUBRO_ARTI_MOTOS_BICICLETAS: 14,
  SUBRUBRO_ARTI_FLETE_POR_DISTANCIA: 15,
  SUBRUBRO_ARTI_VENTA_PREPAGO: 16,
  SUBRUBRO_ARTI_BOLSINES_COMERCIALES: 17,
  SUBRUBRO_ARTI_BOLSAS_DE_SEGURIDAD: 18,
  SUBRUBRO_ARTI_MUEBLES: 53,
  SUBRUBRO_ARTI_SERVICIO_PACK_CREDIFIN: 54,
  SUBRUBRO_ARTI_ENVIO_PREPAGO: 35,
  SUBRUBRO_ARTI_ARTICULO_DEPORTIVO: 44,
  SUBRUBRO_ARTI_ARTICULOS_DE_CAMPING: 45,
  SUBRUBRO_ARTI_JUGUETERIA: 47,
  SUBRUBRO_ARTI_NAUTICA: 49,
  SUBRUBRO_ARTI_ENTREGA: 50,
  SUBRUBRO_ARTI_RETIRO: 51,
  SUBRUBRO_ARTI_SEGUROS: 52,
  SUBRUBRO_ARTI_ADICIONALES: 55,
  SUBRUBRO_ARTI_UPGRADE_PREPAGO: 79,
}

//articulos COMVTAARTICULO
export const ARTICULOS = {
  CREDITO_PREPAGO: 230,
  CREDITO_ANTICIPADO: 247,
  FLETE_DISTANCIA_PESO: 119,
  FLETE_DISTANCIA_VOLUMEN: 126,
  DIFERENCIAL_CREDITO_PREPAGO: 240,
  SEGURO: 192,
  ADICIONAL_ENTREGA: 191,
  ADICIONAL_RETIRO: 190,
  SOBRES: 241
}

export const INPUT = {
  TEXT: "inputText",
  TEXT_DEFAULT: "inputTextDefault",
  CURRENCY: "inputCurrency",
  PERCENTAGE: "inputPercentage",
  NUMBER: "inputNumber",
}

export const SISTEMA_MODULOS = {
  CARGA: 1,
  DESCARGA: 2,
  CONSOLIDADO: 3,
  DESCONSOLIDADO: 4,
}

export const IMPRESION = {
  ETIQUETA: 1,
  GUIA: 2,
  COMPROBANTE: 3,
  RECIBO: 4,
}

export const CONTENEDORES = {
  BIN: 1,
  COLECTORA: 2,
  BOLSIN: 3,
}

export const ALLOWED_IMPRESION_TYPES = [
  {
    id: 1,
    name: 'ZPL',
    description: 'Zebra',
  },
  {
    id: 2,
    name: 'EPL',
    description: 'TLP 2844',
  },
  {
    id: 3,
    name: 'EPL_V2',
    description: 'TLP 2844',
  },
]

export const ACUERDOS_TIPOS_PERSONALIZADOS = {
  DISTANCIA_Y_PESO: 1,
  DISTANCIA_Y_VOLUMEN: 2,
  ARTICULO_ESPECIFICO: 3,
  VALOR_DECLARADO: 4,
};